import { useMemo } from 'react';
import useAsset from './useAsset';
import { useRecurringProject } from '../../api';
export var useProjectScheduleStatus = function(projectIdentifier) {
    var constants = useAsset().constants;
    var _useRecurringProject = useRecurringProject(projectIdentifier), projectSchedule = _useRecurringProject.data, isLoading = _useRecurringProject.isLoading;
    var status = (projectSchedule || {}).status;
    return useMemo(function() {
        return {
            isLoading: isLoading,
            data: projectSchedule ? {
                isDraft: status === constants.PROJECT_SCHEDULE_STATUS_DRAFT,
                isActive: status === constants.PROJECT_SCHEDULE_STATUS_ACTIVE,
                isPaused: status === constants.PROJECT_SCHEDULE_STATUS_PAUSED,
                isComplete: status === constants.PROJECT_SCHEDULE_STATUS_COMPLETE,
                isArchived: status === constants.PROJECT_SCHEDULE_STATUS_ARCHIVED
            } : undefined
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        status,
        JSON.stringify(constants),
        isLoading
    ]);
};
